import React, {useEffect, useState} from 'react';
import {history, useSelector} from 'umi';
import {Layout, Card, Justify, SearchBox, Button, Modal} from 'tea-component';
import UserPackagesTable from '@/pages/datalab/pages/Number/NumberPackage/components/UserPackagesTable';
import SvgIcon from '@/pages/home/components/SvgIcon';

import UploadPackage from '@dbl/pages/Number/NumberPackage/components/UploadPackage';
import {useDblIntl} from "@/pages/datalab/utils/utils";
import {buriedPoint} from "@/pages/home/utils/buriedPoint";
import { AuthPermissionDisablesContainers } from '../../WorkBench/MyDashboard';
import { DATALAB_EDITOR } from '@dbl/core/global';
import './index.scss';

const {Content} = Layout;

function SheetManagement() {
  const { gameCode } = useSelector((state) => ({gameCode: state.datalab.gameCode}));
  const { dblFormatMessage: numFormatMessage, createDblFormatMessage } = useDblIntl("number_package");
  useEffect(() => {
    buriedPoint({
      pageId: '600501',
      pageName: '号码包管理',
      pagePath: '/DataManagement/UserPackagesManagement',
      extInfo: `{"pageName": "User IDs", "pageNameCn": "号码包管理", "id": ""}`,
      uid: gameCode,
      typeId: "datalab_pc_v2",
      menuId: '0',
    });
  }, [gameCode]);

  // 搜索框点击搜索按钮后, 触发表格请求的搜索字段
  const [searchWords, setSearchWords] = useState<string | undefined>('');
  // 搜索框受控value
  const [searchValue, setSearchValue] = useState<string | undefined>('');

  const [requestUserPackagesTable, setRequestUserPackagesTable] = useState<number>(0);
  return (
    <Content>
      <Content.Header title={numFormatMessage("title")}/>
      <Content.Body full className='number_package'>
        <Justify className='number_package_buttom' left={
          <>
            <AuthPermissionDisablesContainers {...{
              type: DATALAB_EDITOR.AddChartBtn
            }}>
              <Button
                type="primary"
                onClick={() => {
                  history.push(`/datalab/${gameCode}/Analysis/PacketExtraction`);
                }}
              >
                {numFormatMessage("extract")}
              </Button>
            </AuthPermissionDisablesContainers>
            <AuthPermissionDisablesContainers {...{
              type: DATALAB_EDITOR.AddChartBtn
            }}>
              <Button
                className='ns-btn--border btn-top'
                onClick={() => {
                  const modal = Modal.show({
                    size: 500,
                    caption: numFormatMessage("upload"),
                    children: (
                      <UploadPackage
                        formatMessage={numFormatMessage}
                        uploadFormatMessage={createDblFormatMessage("upload")}
                        gameCode={gameCode}
                        refreshUserPackagesTable={() => setRequestUserPackagesTable((value) => value + 1)}
                        onClose={() => {
                          modal.destroy();
                        }}
                      />
                    ),
                    onClose: () => {
                      modal.destroy();
                    },
                    disableEscape: true,
                  });
                }}
              >
                <SvgIcon className='btn-top-icon' type="upload" />
                {numFormatMessage("upload")}
              </Button>
            </AuthPermissionDisablesContainers>
          </>
        } right={<SearchBox
          value={searchValue}
          onChange={(value) => {
            setSearchValue(value);
          }}
          onSearch={(keyword) => {
            setSearchWords(keyword);
          }}
          onClear={() => {
            setSearchWords('');
          }}
          className='number_package_search'
          placeholder={numFormatMessage("search")}
        />}/>
        <Card>
          <Card.Body>
            <UserPackagesTable
              gameCode={gameCode}
              searchWords={searchWords}
              requestUserPackagesTable={requestUserPackagesTable}
              clearSearchWords={() => {
                setSearchWords('');
                setSearchValue('');
              }}
            />
          </Card.Body>
        </Card>
      </Content.Body>
    </Content>
  );
}

export default SheetManagement;
